import { render, staticRenderFns } from "./DIgitalTicketChart.vue?vue&type=template&id=3c895d3c&scoped=true&"
import script from "../../models/analysis/digital-ticket-chart.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/digital-ticket-chart.ts?vue&type=script&lang=ts&"
import style0 from "../../styles/analysis/analysis.scss?vue&type=style&index=0&id=3c895d3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c895d3c",
  null
  
)

export default component.exports